<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt01">
<div class="partHead">
<a id="page07">
<h2 class="partTitle" style="text-indent: 0%;"><span class="bold">THE PRINCE’S CHOICE</span></h2>
<p class="partSubtitle" style="text-indent: 0%;"><span class="bold">Rebecca Winters</span></p></a></div><a id="page07">
<div class="partBody">
</div>
</a></div>
<a id="page07">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781426881688_pt01.vue?2094d50c